/**
 * The small uppercase label that heads a block inside a card or a rail.
 */
import type { ReactNode } from "react";
import { cn } from "@unlikelyai-magic/utils";

export const SectionLabel = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-brand-muted",
      className
    )}
  >
    {children}
  </span>
);
